import {
    ServerCIEnvironment,
    ServerEnvironment,
    type ServerBaseUrl
} from '~/servers/types';

/**
 * Server configuration for the Sao Paulo production region (`enterprise.sa.wisesystems.io`)
 */
export const saoPauloServerConfig: ServerBaseUrl = {
    apiServer: 'https://api.sa.wisesys.info',
    auroraApiServer: 'https://aurora-v2.wisesys.info',
    socketServer: 'wss://sa.socket.wisesys.info',
    auroraServer: '',
    environment: ServerEnvironment.SAO_PAULO,
    CIEnv: ServerCIEnvironment.PRODUCTION,
    vehicleProfile:
        'https://ybtfow4mv3.execute-api.us-east-1.amazonaws.com/production',
    routePathGeometryServer:
        'https://ol1vgxgyob.execute-api.us-east-1.amazonaws.com/production',
    configurableWorkflowServer:
        'https://zcqwzh2eue.execute-api.us-east-1.amazonaws.com/Prod',
    driverCostServer:
        'https://lto7uvr6z9.execute-api.us-east-1.amazonaws.com/prod'
};
